(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["psn-batch-lookup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('psn-batch-lookup')) {
    customElements.define('psn-batch-lookup', class extends HTMLElement {
      static normalize(v) { return String(v || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, ''); }
      connectedCallback() {
        this.lots = (this.dataset.lots || '').split(',').filter(Boolean);
        this.input = this.querySelector('input');
        this.miss = this.querySelector('.psn-lookup__miss');
        this.querySelector('form').addEventListener('submit', (e) => { e.preventDefault(); this.lookup(); });
      }
      lookup() {
        const typed = this.input.value.trim();
        const lot = this.constructor.normalize(typed);
        if (!lot) return this.input.focus();
        const found = this.lots.includes(lot);
        if (!found) {
          this.miss.textContent = (this.dataset.missTemplate || '').replace('__LOT__', typed.toUpperCase());
          this.miss.hidden = false;
          return;
        }
        this.miss.hidden = true;
        const url = (this.dataset.urls || '').split(',').map((p) => p.split('=')).find(([l]) => l === lot);
        if (url && url[1]) {
          window.location.href = url[1];
        } else if (this.hasAttribute('data-redirect')) {
          window.location.href = `${this.dataset.page}?lot=${encodeURIComponent(lot)}`;
        } else {
          document.dispatchEvent(new CustomEvent('psn:lot', { detail: { lot, scroll: true } }));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psn-email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('psn-email-popup')) return;
    window.PSN = window.PSN || {};
    const STORAGE_KEY = 'psn-email-popup-seen';
    const EMAIL_RE = PSN.EMAIL_RE || /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

    const seen = () => {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {
        return false;
      }
    };
    const markSeen = () => {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    };

    class PsnEmailPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-psn-popup-form]');
        this.input = this.form.querySelector('input[type="email"]');
        this.error = this.querySelector('[data-psn-popup-error]');
        this.submit = this.querySelector('[data-psn-popup-submit]');
        this.formView = this.querySelector('[data-psn-popup-form-view]');
        this.doneView = this.querySelector('[data-psn-popup-done-view]');
        this.copyBtn = this.querySelector('[data-psn-popup-copy]');
        this.submitLabel = this.submit.textContent.trim();
        PSN._emailPopup = this;

        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.closest('[data-psn-popup-close]')) this.close();
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('psn-scroll-lock');
          if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus();
        });
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
        this.input.addEventListener('input', () => this.setError(false));
        this.copyBtn.addEventListener('click', () => this.copy());

        const params = new URLSearchParams(window.location.search);
        const designMode = window.Shopify && window.Shopify.designMode;
        if (params.get('customer_posted') === 'true' && window.location.hash === '#psn-email-popup-form') {
          markSeen();
          this.open(false);
          this.showDone();
        } else if (!designMode && !seen()) {
          this.timer = setTimeout(() => {
            if (seen() || document.querySelector('dialog[open]')) return;
            markSeen();
            this.open(false);
          }, 900);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      open(reset) {
        clearTimeout(this.timer);
        markSeen();
        if (reset) this.reset();
        if (this.dialog.open) return;
        this.returnFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('psn-scroll-lock');
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      reset() {
        this.formView.hidden = false;
        this.doneView.hidden = true;
        this.form.reset();
        this.setError(false);
        this.setSending(false);
      }

      setError(show) {
        this.error.hidden = !show;
        this.input.setAttribute('aria-invalid', show ? 'true' : 'false');
      }

      setSending(sending) {
        this.submit.disabled = sending;
        this.submit.textContent = sending ? this.dataset.sendingLabel || 'Sending…' : this.submitLabel;
      }

      showDone() {
        this.formView.hidden = true;
        this.doneView.hidden = false;
        const title = this.querySelector('[data-psn-popup-done-title]');
        if (title) title.focus();
      }

      async onSubmit(e) {
        e.preventDefault();
        if (!EMAIL_RE.test(this.input.value.trim())) {
          this.setError(true);
          this.input.focus();
          return;
        }
        this.setError(false);
        this.setSending(true);
        try {
          const res = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' },
          });
          if (/\/challenge/.test(res.url)) throw new Error('challenge');
          if (!res.ok && !res.redirected) throw new Error('failed');
          this.setSending(false);
          this.showDone();
        } catch (err) {
          HTMLFormElement.prototype.submit.call(this.form);
        }
      }

      copy() {
        const code = this.dataset.code;
        const done = () => {
          const label = this.querySelector('[data-psn-popup-copy-label]');
          const status = this.querySelector('[data-psn-popup-status]');
          label.textContent = this.dataset.copiedLabel || 'Copied ✓';
          this.copyBtn.classList.add('is-copied');
          if (status) status.textContent = this.dataset.codeCopiedLabel || 'Code copied';
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => {
            label.textContent = this.dataset.copyLabel || 'Copy';
            this.copyBtn.classList.remove('is-copied');
            if (status) status.textContent = '';
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      }
    }

    customElements.define('psn-email-popup', PsnEmailPopup);

    document.addEventListener('click', (e) => {
      const link = e.target.closest && e.target.closest('a[href="#psn-email-popup"]');
      if (!link || !PSN._emailPopup) return;
      e.preventDefault();
      PSN._emailPopup.open(true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psn-toast"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('psn-toast')) {
    customElements.define('psn-toast', class extends HTMLElement {
      connectedCallback() {
        const message = this.authMessage() || this.discountMessage();
        if (message) this.show(message);
      }

      store(key, value) {
        let prev = null;
        try { prev = sessionStorage.getItem(key); sessionStorage.setItem(key, value); } catch (e) {}
        return prev;
      }

      authMessage() {
        const state = this.dataset.state;
        const prev = this.store('psn-auth', state);
        return prev && prev !== state ? this.dataset[state] : '';
      }

      // Shopify's /discount/CODE link sets this cookie and redirects. It can't tell us yet whether the code is valid (the cart may be empty).
      discountMessage() {
        const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
        if (!match) return '';
        let code = '';
        try { code = decodeURIComponent(match[1]).trim().toUpperCase().slice(0, 40); } catch (e) { return ''; }
        if (!code || this.store('psn-discount', code) === code) return '';
        return this.dataset.discount ? this.dataset.discount.replace('[code]', code) : `Code ${code} added. Your discount shows at checkout.`;
      }

      show(message) {
        const text = this.querySelector('.psn-toast__text');
        // Sit just below the sticky header (its bottom moves with the announcement bar).
        const header = document.querySelector('.psn-header');
        if (header) this.style.setProperty('--psn-toast-top', Math.round(header.getBoundingClientRect().bottom + 12) + 'px');
        this.hidden = false;
        // Fill the live region after it's shown so screen readers announce it.
        requestAnimationFrame(() => (text.textContent = message));
        this.querySelector('.psn-toast__close').addEventListener('click', () => (this.hidden = true));
        setTimeout(() => (this.hidden = true), 6000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
